export const formatMoney = (amount: number, currency: string) => {
  // INR uses lakh grouping (₹1,19,988); other currencies keep thousands grouping.
  return new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0,
  }).format(amount);
};

/**
 * Formats an amount in minor currency units (paise / cents).
 * Divides by 100 before formatting.
 * A null or undefined amount or currency renders as an em dash (—).
 */
export const formatMoneyMinor = (
  amountMinor: number | null | undefined,
  currency: string | null | undefined
): string => {
  if (amountMinor == null || !currency) {
    return '—';
  }
  return formatMoney(amountMinor / 100, currency);
};
